type TenantSessionReset = () => void;

const resetHandlers = new Set<TenantSessionReset>();

/**
 * Registers tenant-bearing state that must be cleared synchronously before the
 * next identity is published. Runes modules register themselves here instead
 * of entering auth.ts's static import graph.
 */
export function registerTenantSessionReset(handler: TenantSessionReset): () => void {
	resetHandlers.add(handler);
	return () => resetHandlers.delete(handler);
}

export function runTenantSessionResets(): void {
	for (const reset of resetHandlers) reset();
}
